__turbopack_context__.v({
  "className": "inter_755b57b8-module__pMf0Fa__className",
});
